import { siteMetadata } from "../../config";

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

const GA_ID = (siteMetadata as any).googleAnalyticsId as string;

const isEnabled = () =>
    typeof window !== "undefined" &&
    process.env.NODE_ENV === "production" &&
    !!GA_ID;

export const hasConsent = () =>
    typeof window !== "undefined" && !!localStorage.getItem("cookie-accept");

let initialised = false;

// Injects gtag.js with send_page_view disabled — callers decide when a
// page_view fires (onRouteUpdate, or the cookie Accept handler for
// mid-session opt-in), so the initial load is never double-counted.
export const initAnalytics = (): void => {
    if (!isEnabled() || initialised) return;
    initialised = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
};

export const trackPageView = (): void => {
    if (!initialised) return;
    window.gtag("event", "page_view", {
        page_path: window.location.pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title,
    });
};
